
const state={
    CartItems:[]
}

const getters={
    CartItemSum(state){
        return state.CartItems.reduce((acc,cur)=>acc+cur.num,0)
    },
    PriceSum(state){
        const subtotal = state.CartItems.map(item=>item.product.price*item.num)
        return subtotal.reduce((acc,cur)=>acc+cur,0)
    }
}

const mutations={
    AddtoCart(state,product){
        return state.CartItems.push(product)
    },
    DeleteItem(state,CartItem){
        state.CartItems.splice(state.CartItems.indexOf(CartItem),1)
    },
    AddNum(state,CartItem){
        CartItem.num ++ 
    },
    MinusNum(state,CartItem){
        CartItem.num --
    },
    Checkout(state,CartItem){
        alert("購買完成！")
        state.CartItems=[]
    }
    
}

const actions= {
    PushtoCart(context,product,NumtoBuy){
        const ProductID = product.id
        const CartItem = state.CartItems.find(item=>item.product.id===ProductID)
        if (CartItem){
            context.commit('AddNum',CartItem)
            alert(`成功加入「${product.title} ${product.tag}」至購物車`)
        } else {
            context.commit('AddtoCart',{product,num:1})
            alert(`成功加入「${product.title} ${product.tag}」至購物車`)
        }
    },
    DeleteItem(context,CartItem){
        context.commit('DeleteItem',CartItem)
    },
    AddNum(context,CartItem){
        context.commit('AddNum',CartItem)
    },
    MinusNum(context,CartItem){
        if (CartItem.num>0){
            context.commit('MinusNum',CartItem)
        } else if (CartItem.num=0){
            context.commit('DeleteItem',CartItem)
        } else {
            context.commit('DeleteItem',CartItem)
        }
    },
    Checkout(context,CartItem){
        context.commit('Checkout',CartItem)
    }

}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/cart.js